import PropTypes from 'prop-types';
import React from 'react';

const BanksListNames = (props) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      props.handlerSelectOption(e);
    }
  };

  if (props.inputUseBar) {
    return null;
  }

  return (
    <div
      className="banks-list-option"
      data-aut-test="box-list-bank-names-select"
      data-testid="box-list-bank-names-select"
    >
      <ul
        className="bank-options"
        data-aut-test="list-bank-names-select"
        data-testid="list-bank-names-select"
      >
        {props.banksListOptions.map((bank) => {
          return (
            <li key={bank.code}>
              <button
                onClick={props.handlerSelectOption}
                onKeyDown={handleKeyDown}
                data-testid={`code-${bank.code}`}
                data-bank-option={JSON.stringify(bank)}
                type="button"
              >
                {bank.code} - {bank.name}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

BanksListNames.propTypes = {
  banksListOptions: PropTypes.array,
  handlerSelectOption: PropTypes.func,
  inputUseBar: PropTypes.bool
};

export default BanksListNames;
